"use client";

import { HeroSection } from "@/components/shared/public";
import { useTranslations } from "next-intl";
import { letterHeadMockUp } from "../../../../public/images/floor-plans";

const Hero = () => {
  const tC = useTranslations("common");
  const tS = useTranslations("sized.hero");

  return (
    <HeroSection
      image={letterHeadMockUp}
      alt={"Wohnflächenberechnung Beispiel"}
      tab={tC("sizedFloorPlans")}
      title={tS("title")}
      text={tS("text")}
      linkTitle={tC("optimizeNow")}
      href={"/user/order-sized-floor-plan"}
      height={300}
      width={400}
    />
  );
};

export default Hero;
